// simple shared flags to coordinate signup and auth state fetches
export const authFlowFlags = {
  signupInProgress: false,
};